import { ReceivedInvoiceAiSuggestStatusProperty } from '@/context/services/invoice/type';
import { isAiSuggestProcessing } from '@/features/invoices/utils/aiSuggestStatus';
import { usePaymentRequestSupportAgentFlag } from '@/hooks/feature_flag/usePaymentRequestSupportAgentFlag';
import { FC, PropsWithChildren, createContext, useContext } from 'react';

const Context = createContext<
  ReceivedInvoiceAiSuggestStatusProperty | undefined
>(undefined);

type Props = {
  value: ReceivedInvoiceAiSuggestStatusProperty | undefined;
};

export const AiSuggestStatusProvider: FC<PropsWithChildren<Props>> = ({
  value,
  children,
}) => {
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

/**
 * `overrideValue` lets callers outside the provider tree (e.g. list rows,
 * which get their status per-row rather than from context) share the same
 * flag-gating logic instead of duplicating `isEnabled && isAiSuggestProcessing`.
 */
export const useAiSuggestStatusChecker = (
  overrideValue?: ReceivedInvoiceAiSuggestStatusProperty
) => {
  const contextValue = useContext(Context);
  const value = overrideValue ?? contextValue;
  const isEnabled = usePaymentRequestSupportAgentFlag();
  return {
    isEnabled,
    isProcessing: isEnabled && isAiSuggestProcessing(value),
  };
};
